module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-replace-banner'), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.serviceGuarantee,
      "isSecond": false,
      "slogan": "服务保障",
      "description": "7*24全天候服务，资深木材行业服务工程师提供一对一服务。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.serviceSpot,
      "isSecond": true,
      "slogan": "服务站点",
      "description": "满洲里、二连浩特、天津、青岛等货源口岸建立站点，服务商家。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.sourceGuarantee,
      "isSecond": false,
      "slogan": "货源保障",
      "description": "严格根据商家需求，货场直接查找货源，提供真实商品信息。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.processVisualization,
      "isSecond": true,
      "slogan": "流程可视化",
      "description": "从需求、货源鉴定、付款、装车、发货等全流程实时汇报。"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68ad1751!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/service_intro/replace/HomeReplaceContent.vue
// module id = 156
// module chunks = 1